<script>
import Sidebar from "components/listings/Sidebar";
import ListTable from "components/listings/Table";
import Pagination from "components/listings/Pagination";
import PageSize from "components/listings/PageSize";
import ExportModal from "components/listings/ExportModal";
import Url from "../helpers/Url";

export default {
  components: {
    Sidebar,
    ListTable,
    Pagination,
    PageSize,
    ExportModal,
  },
  props: {
    columns: { type: Array, default: () => [] },
    defaultParams: { type: Object, default: () => {} },
    filterTypes: { type: Array, default: () => [] },
    listingUrl: { type: String, required: true },
    exportUrl: { type: String },
    summaryUrl: { type: String },
  },
  data() {
    return {
      // list query parameters
      keywords: "",
      filters: {},
      pagination: {
        current: 1,
        per_page: 10,
      },
      sort: {
        column: "id",
        dir: "asc",
      },
      loadingTimeout: null,
      customFilters: [],
      // list query results
      items: [],
      totalItems: 0,
      totalPages: 0,
      activeColumns: [],
      hideNoResults: true,
      // context menus
      listEvents: new Vue(),
      // details panes
      selectedItem: null,
      selectedTab: null,
    };
  },
  computed: {
    hasFilters() {
      return Object.keys(this.filters).length > 0;
    },
    currentFilters() {
      var filters = [];
      if (this.hasFilters) {
        Object.keys(this.filters).forEach((type) => {
          var values = this.filters[type];
          if (
            values.length > 0 &&
            !this.customFilters.find((cf) => cf == type)
          ) {
            values.forEach((value) => {
              filters.push({
                type: type,
                value: value,
                label: this.getFilterValueLabel(type, value),
              });
            });
          }
        });
      }
      return filters;
    },
    showDetailsPane() {
      return !!this.selectedItem;
    },
  },
  watch: {
    keywords: function (val) {
      this.refresh();
    },
    filters: function (val) {
      this.refresh();
    },
    pagination: {
      handler: function (val) {
        this.refresh();
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.refresh();
      },
      deep: true,
    },
    activeColumns: function (val) {
      // this.refresh();
    },
  },
  methods: {
    refresh: _.debounce(function () {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => {
        this.$root.showLoading();
      }, 1000);

      this.axios
        .get(this.listingUrl, {
          params: this.queryParams(),
        })
        .then((response) => {
          this.totalItems = response.data.total_results;
          this.totalPages = response.data.total_pages;
          this.items = response.data.results;
          this.hideNoResults = false;

          this.setSelectedItem(null);

          clearTimeout(this.loadingTimeout);
          this.$root.hideLoading();
        })
        .catch((error) => {
          console.error(error);
        });
    }, 300),
    queryParams() {
      return _.merge(
        {
          ...(this.keywords.length > 0 ? { keywords: this.keywords } : {}),
          ...(Object.keys(this.filters).length > 0
            ? this.stringifyFilters(this.filters)
            : {}),
          ...{ "pagination[current]": this.pagination.current },
          ...{ "pagination[per_page]": this.pagination.per_page },
          ...{ "sort[column]": this.sort.column },
          ...{ "sort[dir]": this.sort.dir },
          ...{ columns: this.activeColumns },
        },
        this.customParams()
      );
    },
    customParams() {
      return {};
    },
    stringifyFilters(filters) {
      return _.reduce(
        filters,
        (result, values, type) => {
          result[`filters[${type}]`] = values;
          return result;
        },
        {}
      );
    },
    loadParams() {
      Object.keys(this.defaultParams).forEach((key) => {
        if (key == "columns" && _.isArray(this.defaultParams[key])) {
          this.activeColumns = this.defaultParams[key];
        } else if (key == "filters") {
          var val = this.defaultParams[key];
          this.filters = _.isObject(val) ? _.cloneDeep(val) : {};
        } else if (_.has(this, key)) {
          var val = this.defaultParams[key];
          this[key] = _.isObject(val) ? _.cloneDeep(val) : val;
        }
      });
    },
    getFilterValueLabel(type, value) {
      var label = `${value}`;
      this.filterTypes.forEach((t) => {
        if (t.key == type) {
          t.options.forEach((o) => {
            if (o.value == value) {
              label = `${t.label}: ${o.label}`;
            }
          });
        }
      });
      return label;
    },
    setKeywords(val) {
      this.keywords = val;
      this.pagination.current = 1;
    },
    addFilter(type, value) {
      this.setCurrentPage(1);
      var filters = this.filters;
      this.filters = {};
      !!filters[type] ? filters[type].push(value) : (filters[type] = [value]);
      this.filters = filters;
    },
    replaceFilter(type, value) {
      var filters = this.filters;
      this.filters = {};
      filters[type] = _.isArray(value) ? value : [value];
      this.filters = filters;
    },
    removeFilter(type, value) {
      var filters = this.filters;
      this.filters = {};
      Object.keys(filters).forEach((t) => {
        var values = filters[t];
        if (t != type) {
          this.filters[t] = values;
        } else {
          this.filters[t] =
            _.filter(values, (v) => {
              return v != value;
            }) || [];
        }
      });
    },
    clearFilter(type) {
      var filters = this.filters;
      this.filters = {};
      Object.keys(filters).forEach((t) => {
        var values = filters[t];
        if (t != type) {
          this.filters[t] = values;
        }
      });
    },
    removeAllFilters() {
      this.keywords = "";
      this.filters = {};
      this.pagination.current = 1;
      this.$root.eventBus.$emit('clear-all-filters')
    },
    setSort(column, dir) {
      this.sort.column = column.key;
      this.sort.dir = dir;
    },
    setCurrentPage(val) {
      this.pagination.current = val;
    },
    setPerPage(val) {
      this.pagination.per_page = val;
      if (this.totalItems > 0) {
        var totalPages = Math.ceil(this.totalItems / val);
        if (totalPages < this.pagination.current) {
          this.pagination.current = 1;
        }
      }
    },
    setActiveColumn(column, index) {
      var activeColumns = this.activeColumns;
      this.activeColumns = [];
      this.activeColumns = activeColumns.map((c, i) => {
        return i == index ? column : c;
      });
    },
    setSelectedItem(item, tab) {
      this.selectedItem = item;
      this.selectedTab = tab || null;
    },
    showExportOptions() {
      if (!!this.exportUrl) {
        this.$modal(ExportModal)
          .then(this.exportList)
          .catch(() => {});
      }
    },
    exportList(option) {
      let current_page = this.pagination.current;
      let per_page = this.pagination.per_page;
      let final_page = null;

      if (option.option == "all") {
        current_page = 1;
        per_page = 2000;
      } else if (option.option == "range") {
        current_page = parseInt(option.start, 10) || 1;
        final_page = parseInt(option.end, 10) || 1;
      }

      let params = _.merge(this.queryParams(), {
        "pagination[current]": current_page,
        "pagination[per_page]": per_page,
      });

      if (!!final_page) {
        params["pagination[final]"] = final_page;
      }

      window.location = this.exportUrl + "?" + Url.toQueryString(params);
    },
    exportSummary() {
      window.location = this.summaryUrl + "?" + Url.toQueryString(this.queryParams());
    },
    booleanColumn(item, prop) {
      return !!item[prop] ? "Yes" : "No";
    },
  },
  created() {
    this.loadParams();
  },
  mounted() {
    this.listEvents.$on("refresh", this.refresh);
  },
};
</script>